import { Link } from "react-router-dom";
import styles from "../styles/Listings.module.css";

// create a function to create a single dropdown for a unit

const createAssignmentListings = (unit: string, id: string) => {
    return (
        <li className={styles.listing} >
            <Link to={id}>
                {unit}
            </Link>
        </li>
    );
};

export default function UnitListings(config: { assignments: Assignment[] }) {
    const { assignments } = config;
    // create a NEXTJS vertical list of units buttons that dropdown to a list of lessons in the unit which leads to a link ref for the units given in the list

    const unitList = assignments.map((assignment) => {
        return createAssignmentListings(assignment.name, assignment.id);
    });

    return (
        <>
            {" "}
            <details className={styles.listing}>
                <summary>
                    <h2>Assignments</h2>
                </summary>
                <ul className={styles.listings}>{unitList}</ul>
            </details>
        </>
    );
}
